interface Color {
  color: string;
  gradient: string;
}

interface Pallete {
  [key: string]: Color;
}

export const pallete: Pallete = {
  blue: {
    color: "#1E85D9",
    gradient: "linear-gradient(0deg, rgba(51, 163, 255, 0.08), rgba(51, 163, 255, 0.08)), #FFFFFF",
  },
  purple: {
    color: "#9B51E0",
    gradient: "linear-gradient(0deg, rgba(187, 107, 217, 0.08), rgba(187, 107, 217, 0.08)), #FFFFFF",
  },
  green: {
    color: "#2AB561",
    gradient: "linear-gradient(0deg, rgba(42, 181, 97, 0.08), rgba(42, 181, 97, 0.08)), #FFFFFF",
  },
  orange: {
    color: "#F2994A",
    gradient: "linear-gradient(0deg, rgba(242, 153, 74, 0.08), rgba(242, 153, 74, 0.08)), #FFFFFF",
  },
  yellow: {
    color: "#F2C94C",
    gradient: "linear-gradient(0deg, rgba(242, 201, 76, 0.08), rgba(242, 201, 76, 0.08)), #FFFFFF",
  },
  lightBlue: {
    color: "#56CCF2",
    gradient: "linear-gradient(0deg, rgba(86, 204, 242, 0.08), rgba(86, 204, 242, 0.08)), #FFFFFF",
  },
  lightGreen: {
    color: "#6FCF97",
    gradient: "linear-gradient(0deg, rgba(111, 207, 151, 0.08), rgba(111, 207, 151, 0.08)), #FFFFFF",
  },
  red: {
    color: "#EC3D39",
    gradient: "linear-gradient(0deg, rgba(255, 91, 87, 0.08), rgba(255, 91, 87, 0.08)), #FFFFFF",
  },
  darkOrange: {
    color: "#E17055",
    gradient: "linear-gradient(0deg, rgba(225, 112, 85, 0.08), rgba(225, 112, 85, 0.08)), #FFFFFF",
  },
  pink: {
    color: "#E84393",
    gradient: "linear-gradient(0deg, rgba(232, 67, 147, 0.08), rgba(232, 67, 147, 0.08)), #FFFFFF",
  },
  darkBlue: {
    color: "#5F27CD",
    gradient: "linear-gradient(0deg, rgba(95, 39, 205, 0.08), rgba(95, 39, 205, 0.08)), #FFFFFF",
  },
};

export const getRandomColor = () => {
  const keys = Object.keys(pallete);
  return keys[Math.floor(Math.random() * keys.length)];
};

export const getColorByName = (name: string) => {
  return pallete[name];
};
